// extracted by mini-css-extract-plugin
module.exports = {"NutritionImg":"NutritionInfo_NutritionImg__1wLC9","Amount":"NutritionInfo_Amount__2fjPQ"};